module.exports = __webpack_public_path__ + "static/media/erp-business-10.fd16dc36.png";